import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-hero-icon',
  templateUrl: 'hero.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeroIcon { }
